module.exports = __webpack_public_path__ + "static/media/img.5c23d35b.jpg";